import { useMutation, useQuery, useQueryClient } from 'react-query'
import { api } from '../../utils/api'
import {
  AddProductToCartParams,
  DeleteProductToCartParams,
  OrderDetail,
  UserCartDetail,
} from './cart-typed'

export const SHOP_URL = '/app/cart'

export const USER_CART_URL = `${SHOP_URL}/getUserCart`
export const ADD_PRODUCT_TO_CART_URL = `${SHOP_URL}/addProductToCart`
export const UPDATE_PRODUCT_IN_CART_URL = `${SHOP_URL}/updateProductInCart`
export const DELETE_PRODUCT_IN_CART_URL = `${SHOP_URL}/deleteProductInCart`
export const GET_SUM_PRICE_IN_CART_URL = `${SHOP_URL}/getSumPriceInCart`
export const GET_ORDER_URL = `${SHOP_URL}/getOrder`

export const useGetUserCart = () => {
  return useQuery<UserCartDetail | undefined, Error>(USER_CART_URL, () =>
    api.belive.get<UserCartDetail>(USER_CART_URL),
  )
}

export const useAddProductToCart = () => {
  return useMutation(
    (params: AddProductToCartParams) => {
      return api.belive.post(
        `${ADD_PRODUCT_TO_CART_URL}?productId=${params.productId}&quantity=${params.quantity}`,
      )
    },
    {
      onSuccess: (data) => {
        console.log(data)
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
}

export const useUpdateProductInCart = () => {
  const queryClient = useQueryClient()
  return useMutation(
    (params: AddProductToCartParams) => {
      return api.belive.put(
        `${UPDATE_PRODUCT_IN_CART_URL}?productId=${params.productId}&quantity=${params.quantity}`,
      )
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(USER_CART_URL)
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
}

export const useDeleteProductInCart = () => {
  const queryClient = useQueryClient()
  return useMutation(
    (params: DeleteProductToCartParams) => {
      return api.belive.delete(`${DELETE_PRODUCT_IN_CART_URL}?productId=${params.productId}`)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(USER_CART_URL)
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
}

export const useGetSumPriceInCart = () => {
  return useQuery(GET_SUM_PRICE_IN_CART_URL, () => {
    return api.belive.get<string>(GET_SUM_PRICE_IN_CART_URL)
  })
}

export const useGetOrder = () => {
  return useQuery<OrderDetail[]>(GET_ORDER_URL, () => api.belive.get<OrderDetail[]>(GET_ORDER_URL))
}
